'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var BubbleItem = require('./BubbleItem.js');
var FlashingBubbleItems = require('./FlashingBubbleItems.js');
var type = require('../type.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Bubbles = ({ items, layout, position }) => {
  const filterItems = items.filter((item) => {
    var _a;
    return !!((_a = item == null ? void 0 : item.icon) == null ? void 0 : _a.src);
  });
  switch (layout) {
    case type.ContactBubbleLayout.VERTICAL:
      return /* @__PURE__ */ jsxRuntime.jsx(VerticalBubbles, {
        children: filterItems.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(BubbleItem.BubbleItem, {
          item,
          position
        }, index))
      });
    case type.ContactBubbleLayout.FLASH:
      return /* @__PURE__ */ jsxRuntime.jsx(FlashingBubbleItems.FlashingBubbleItems, {
        items: filterItems,
        position
      });
    default:
      return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {});
  }
};
const VerticalBubbles = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`;

exports.Bubbles = Bubbles;
